class GlobalRawMaterials extends HTMLElement {
    constructor() {
        super()
        this.selectors = {
            region          : '[js-global-raw-tabs]',
            regionElement   : '[js-region-data]',
            regionCountry   : '[js-region-country-selector]'
        }
        this.allCountriesData = cs_countries_name;
                                 
        this.allRegionMaps = this.querySelectorAll(this.selectors.regionElement)
        this.currentRegion = '';
        this.currentRegionValue = 'europa'
        this.init()
    }
    init() {
        
        // top region selector, initially select first region
        this.regionsSelector = this.querySelectorAll(this.selectors.region)
        
        if(this.regionsSelector) {
            this.regionsSelector.forEach(region => {
                region.addEventListener('click', (e) => {
                    this.regionHandler(e)
                })
            })
            this.regionsSelector[0]?.click()
        }

        // inner-map country selector logic
        this.countries = this.querySelectorAll(this.selectors.regionCountry);

        if(this.countries) {
            this.countries.forEach(country => {
                country.addEventListener('click', (e) => {
                    this.countryHandler(e)
                })
            })
        }

        this.querySelectorAll(`${this.selectors.regionCountry}.init-selected`).forEach((point, i) => {
            if(i==0) {
                this.querySelector('[data-region-value="europa"]').click()
            } else if(i == 1) {
                this.querySelector('[data-region-value="asien"]').click()
            }
            point.click();
        }); 
        // select first tab
        this.querySelector('[data-region-value="europa"]').click()
    }

    regionHandler(e) {
        const regionSelectTab = e.target.closest(this.selectors.region)
        const dataRegionValue = regionSelectTab?.dataset.regionValue
        if(dataRegionValue) {
            this.regionsSelector.forEach(x => x.classList.remove('active'))
            !regionSelectTab.classList.contains('active') ? regionSelectTab.classList.add('active') :""
            this.currentRegionValue = dataRegionValue
            this.currentRegion = this.allCountriesData[`${dataRegionValue}`]
            this.allRegionMaps.forEach(x => x.classList.add('hide'))
            this.querySelector(`${this.selectors.regionElement}[data-value='${dataRegionValue}']`)?.classList.remove('hide')
        }
    }
    countryHandler(e) {
        const currentCountry = e.target.closest(this.selectors.regionCountry);
        const currentConrtyPoints = currentCountry.closest(`${this.selectors.regionElement}`).querySelectorAll(this.selectors.regionCountry);
        const currentCountryName = currentCountry.dataset.value
        this.currentRegion = this.allCountriesData[`${this.currentRegionValue}`]
      
        if(currentCountryName) {
            currentConrtyPoints.forEach(x => x.classList.contains('active') ? x.classList.remove('active') :'')
            currentCountry.classList.add('active')
            this.renderContent(currentCountryName, this.currentRegion[`${currentCountryName}`], currentCountry, currentCountry.closest(`${this.selectors.regionElement}`))
        }
    }

    renderContent(countryName, countryDetails, currentCountry, parent_) {
        let node_ = ''
        parent_.querySelector('[js-country-title]').textContent = countryName
        countryName =  countryName.toLowerCase()

        
        if(countryDetails) {
            countryDetails.map(country_ => {
                node_ += `<div class="content-alpha-inner">
                        <div class="text-with-icon">
                            <div class="icon">
                                <img width="${country_.iconWidth}" height="${country_.iconHeight}" src="${country_.icon}">
                            </div>
                            <div class="text">${ country_.name }</div>
                        </div>
                    </div>`
            })
        }
        parent_.querySelector('.inner_content-wrapper').innerHTML = ''
        parent_.querySelector('.inner_content-wrapper').insertAdjacentHTML('beforeend',node_)
        node_ = ''
          
    }
}

customElements.define('global-raw-meterial', GlobalRawMaterials)